const EncryptEmail = async (email: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(email.toUpperCase());
  const buffer = await crypto.subtle.digest('SHA-256', data);

  // Convert buffer to hexadecimal string
  const hexString = Array.from(new Uint8Array(buffer))
    .map((byte) => ('00' + byte.toString(16)).slice(-2))
    .join('');

  return '0x' + hexString.toUpperCase();
};

export default EncryptEmail;
